"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importDefault(require("react"));
const utilities_1 = require("./utilities");
function Switch(props) {
    let children = props.children;
    if (!children) {
        children = [];
    }
    let defaultCase = null;
    for (const child of props.children) {
        if ((0, utilities_1.isCase)(child)) {
            if (child.props.when === props.on) {
                return child;
            }
        }
        else if ((0, utilities_1.isDefault)(child)) {
            defaultCase = child;
        }
    }
    if (defaultCase) {
        return defaultCase;
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.Switch = Switch;
//# sourceMappingURL=Switch.js.map